import Repository from './Repository'

const resource = '/twilio-phones'
const resourceHoliday = '/holidays'
const resourceHolidayGroup = '/holiday-groups'
const resourceOuttimes = '/outtimes'

export default {
  // list call queuing
  async getListTwilioPhone() {
    return await Repository.get(resource)
  },

  // holiday
  async addHoliday(params) {
    try {
      return await Repository.post(`${resourceHoliday}/multiple`, params)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async copyHoliday (params) {
    const { id, data } = params
    try {
      return await Repository.post(`${resourceHolidayGroup}/copy/${id}`, data)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async editHoliday (params) {
    const { id, data } = params
    try {
      return await Repository.patch(`${resourceHoliday}/group/${id}`, data)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getListHoliday(id, year) {
    return await Repository.get(resourceHoliday + '/group/' + id + '?year=' + year)
  },
  async getListHolidayAll(id) {
    return await Repository.get(resourceHoliday + '/group/' + id)
  },

  async getListHolidayGroup(phone) {
    return await Repository.get(resourceHolidayGroup + '?phone_number=' + phone)
  },

  async deleteHoliday (id) {
    try {
      return await Repository.delete(`${resourceHoliday}/${id}`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async updateGroupHoliday(payload) {
    try {
      return await Repository.post(`${resource}/update-holiday-group/${payload.phoneNumber}`, {
        holidayGroupId: payload.id
      })
    } catch (e) {
      return this.setErrors(e)
    }
  },

  // outtime
  async deleteOutTimes (id) {
    try {
      return await Repository.delete(`${resourceOuttimes}/${id}`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async detailOutTimes (phone, params) {
    try {
      return await Repository.get(`${resourceOuttimes}/twilio-phone/${phone}?option=${params}`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async updateWeekly(id, params) {
    try {
      return await Repository.post(`${resource}/update-outtime/${id}`, params, { headers: { 'content-type': 'multipart/form-data' } })
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async updateOnlyOuttime(id, params) {
    try {
      return await Repository.patch(`${resourceOuttimes}/${id}`, params, { headers: { 'content-type': 'multipart/form-data' } })
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async createOuttime(phone, params) {
    try {
      return await Repository.post(`${resourceOuttimes}/multiple/${phone}`, params, { headers: { 'content-type': 'multipart/form-data' } })
    } catch (e) {
      return this.setErrors(e)
    }
  },

  // waitting
  async updateWaiting(id, params) {
    try {
      return await Repository.patch(`${resource}/${id}`, params, { headers: { 'content-type': 'multipart/form-data' } })
    } catch (e) {
      return this.setErrors(e)
    }
  },

  setErrors (e) {
    const errorCode = e.response ? e.response.status : 500
    return {
      status: false,
      errorCode: errorCode,
      data: e.response?.data || 'error',
      error: e
    }
  },
  catchError(e) {
    return e.response ? e.response.data : 'error'
  }
}
